// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';
import Form from './Form';

const initialValues = {
    offer: '',
    subject: '',
    note: '',
};

const initialErrors = {
    offer: '',
    subject: '',
    note: ''
};

let abortController;

const DialogEdit = (props) => {
    const [loading, setLoading] = useState(true);
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    const fetch = (abortController) => {
        props.fetch.get(`/api/notes/${props.selectedNote.id}/`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setValues({...values, note: data.note});
                }
                setLoading(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            });
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let _abortController = new AbortController();
        if (props.open) {
            setLoading(true);
            fetch(_abortController);
        }
        return () => {
            _abortController.abort();
        };
    }, [props.open]);

    useEffect(() => {
        if (props.selectedNote) {
            setValues({
                offer: props.selectedNote.offer.id.toString(),
                subject: props.selectedNote.subject,
                note: '',
            });
        }
    }, [props.selectedNote]);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.put(`/api/notes/${props.selectedNote.id}/`, values, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    clear();
                    props.onOk(data);
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.offer = (data.offer) ? data.offer[0] : '';
                    _errors.subject = (data.subject) ? data.subject[0] : '';
                    _errors.note = (data.note) ? data.note[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        props.setSelectedNote(null);
    };

    return (
        <DialogForm id="notes-dialog-edit" title="Изменение заметки" label="Изменить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    loading={loading} disabled={fetching}
        >
            <Form values={values} onChange={handleChange} errors={errors} onFocus={handleFocus}/>
        </DialogForm>
    );
};

DialogEdit.propTypes = {
    selectedNote: PropTypes.object,
    setSelectedNote: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogEdit;
Component = withFetch(Component);

export default Component;
